function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 21V4a1 1 0 00-1-1h-8a1 1 0 00-1 1v17M7.5 9h-4a1 1 0 00-1 1v11M22.5 21V10a1 1 0 00-1-1h-4M10 17h5M14 17v4M11 21v-4M10.5 10.5h4M10.5 13.5h4M10.5 7.5h4M5.5 13.5h2M5.5 17h2M17.5 13.5h2M17.5 17h2M23.5 21h-22",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHousing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHousing;